import { CircularProgress, Stack } from "@mui/material";

import { useSwrFetch } from "hooks";

import { QuoteHistory } from "./QuoteHistory";

interface Props {
  quoteId: number;
}

export function QuoteHistoryContainer(props: Props) {
  const { quoteId } = props;
  const {
    data: quote,
    loading,
    error,
  } = useSwrFetch<QuoteInfo>({
    url: `/quotes/${quoteId}`,
    errorMessage: "Failed to fetch quote history.",
  });

  if (loading) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  return <QuoteHistory error={error} actions={quote?.quote_actions ?? []} />;
}
